import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { ImageLink } from "../constants";
import CommonEditor from "../masterpages/CommonEditor";

const Setting = () => {
  const [settingData, setSettingData] = useState([]);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    headerLogo: "",
    headerStickyLogo: "",
    footerLogo: "",
    favicon: "",
    uploadBrochure: "",
    cultureVideo: "",
    title: "",
    headOffice: "",
    contactEmail: "",
    contactNumber: "",
    officeMapUrl: "",
    titleAdd: "",
    headOfficeAdd: "",
    contactEmailAdd: "",
    contactNumberAdd: "",
    officeMapUrlAdd: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`settings/getSettings`);
      const { data } = response.data;
      setSettingData(data);
      setData({ ...data });
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }

    if (files && files.length > 0) {
      const file = files[0];
      // Check the file type and handle accordingly
      if (
        name === "headerLogo" ||
        name === "headerStickyLogo" ||
        name === "footerLogo" ||
        name === "favicon"
      ) {
        // Check if the file type is image
        if (!file.type.startsWith("image/")) {
          e.target.value = null; // Clear input visually
          return toast.error("Only image files (JPEG, JPG, PNG, WEBP) are allowed");
        }
        setData({ ...data, [name]: file });
      } else if (name === "cultureVideo") {
        if (!file.type.startsWith("video/")) {
          e.target.value = null; // Clear input visually
          return toast.error("Only video files are allowed");
        }
        setData({ ...data, [name]: file });
      } else if (name === "uploadBrochure") {
        if (file.type !== "application/pdf") {
          e.target.value = null; // Clear input visually
          return toast.error("Only PDF files are allowed");
        }
        setData({ ...data, [name]: file });
      } else {
        setData({ ...data, [name]: file });
      }
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const isHtmlEmpty = (html) => !html || html.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, '').trim() === '';

    if (!data.title?.trim()) newErrors.title = "Title is required";
    if (isHtmlEmpty(data.headOffice)) newErrors.headOffice = "Address is required";
    
    if (!data.contactEmail?.trim()) {
      newErrors.contactEmail = "Email is required";
    } else if (!emailRegex.test(data.contactEmail)) {
      newErrors.contactEmail = "Invalid email format";
    }

   

    if (!data.officeMapUrl?.trim()) {
      newErrors.officeMapUrl = "Office map URL is required";
    }

    // if (!data.titleAdd?.trim()) newErrors.titleAdd = "Title is required";
    // if (isHtmlEmpty(data.headOfficeAdd)) newErrors.headOfficeAdd = "Address is required";

    if (!data.contactEmailAdd?.trim()) {
      newErrors.contactEmailAdd = "Email is required";
    } else if (!emailRegex.test(data.contactEmailAdd)) {
      newErrors.contactEmailAdd = "Invalid email format";
    }

    // if (!data.contactNumberAdd?.trim()) {
    //   newErrors.contactNumberAdd = "Contact number is required";
    // } else if (!/^\+?[0-9\s\-]{7,15}$/.test(data.contactNumberAdd)) {
    //   newErrors.contactNumberAdd = "Invalid contact number format";
    // }

    if (!data.officeMapUrlAdd?.trim()) {
      newErrors.officeMapUrlAdd = "Office map URL is required";
    }

    if (!data.headerLogo) newErrors.headerLogo = "Header logo is required";
    if (!data.headerStickyLogo) newErrors.headerStickyLogo = "Header sticky logo is required";
    if (!data.footerLogo) newErrors.footerLogo = "Footer logo is required";
    if (!data.favicon) newErrors.favicon = "Favicon is required";
    // if (!data.cultureVideo) newErrors.cultureVideo = "Culture video is required";
    // if (!data.uploadBrochure) newErrors.uploadBrochure = "Brochure is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fix the validation errors before submitting.");
      return;
    }
    try {
      const formData = new FormData();
      if (data.headerLogo instanceof File) {
        formData.append("headerLogo", data.headerLogo);
      }
      if (data.headerStickyLogo instanceof File) {
        formData.append("headerStickyLogo", data.headerStickyLogo);
      }
      if (data.footerLogo instanceof File) {
        formData.append("footerLogo", data.footerLogo);
      }
      if (data.favicon instanceof File) {
        formData.append("favicon", data.favicon);
      }
      formData.append("title", data.title);
      formData.append("headOffice", data.headOffice);
      formData.append("contactEmail", data.contactEmail);
      formData.append("contactNumber", data.contactNumber);
      formData.append("officeMapUrl", data.officeMapUrl);
      formData.append("titleAdd", data.titleAdd);
      formData.append("headOfficeAdd", data.headOfficeAdd);
      formData.append("contactEmailAdd", data.contactEmailAdd);
      formData.append("contactNumberAdd", data.contactNumberAdd);
      formData.append("officeMapUrlAdd", data.officeMapUrlAdd);
      if (data.cultureVideo instanceof File) {
        formData.append("cultureVideo", data.cultureVideo);
      }

      if (data.uploadBrochure instanceof File) {
        formData.append("uploadBrochure", data.uploadBrochure);
      }

      const response = await axiosInstance.put(
        `settings/updateSettings`,
        formData
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        fetchData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };


  const generateSitemap = async () => {
    try {
      const response = await axiosInstance.get(`admin/sitemap`);
      if (response.status === 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5 mx-4">
          <h3 className="page-title">Site Settings </h3>
        </div>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="col-md-8  ">
            <div className="card">
              <div className="card-body">
                <form className="pt-3" onSubmit={handleUpdate}>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Header Logo
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className={`form-control form-control-sm ${errors.headerLogo ? "border-danger" : ""}`}
                        id="headerLogo"
                        name="headerLogo"
                        onChange={handleChange}
                      />
                      {errors.headerLogo && <div className="text-danger small mt-1">{errors.headerLogo}</div>}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Header Sticky Logo
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className={`form-control form-control-sm ${errors.headerStickyLogo ? "border-danger" : ""}`}
                        id="headerStickyLogo"
                        name="headerStickyLogo"
                        onChange={handleChange}
                      />
                      {errors.headerStickyLogo && <div className="text-danger small mt-1">{errors.headerStickyLogo}</div>}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Footer Logo
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className={`form-control form-control-sm ${errors.footerLogo ? "border-danger" : ""}`}
                        id="footerLogo"
                        name="footerLogo"
                        onChange={handleChange}
                      />
                      {errors.footerLogo && <div className="text-danger small mt-1">{errors.footerLogo}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Favicon
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className={`form-control form-control-sm ${errors.favicon ? "border-danger" : ""}`}
                        id="favicon"
                        name="favicon"
                        onChange={handleChange}
                      />
                      {errors.favicon && <div className="text-danger small mt-1">{errors.favicon}</div>}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-12 col-form-label"
                    >
                      Address
                    </label>
                  </div>
                  <hr />
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Title
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.title ? "border-danger" : ""}`}
                        id="title"
                        name="title"
                        placeholder="Enter title"
                        value={data.title}
                        onChange={handleChange}
                      />
                      {errors.title && <div className="text-danger small mt-1">{errors.title}</div>}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Address
                    </label>
                    <div className="col-sm-9">
                      <div className={errors.headOffice ? "border border-danger rounded" : ""}>
                        <CommonEditor
                          value={data.headOffice}
                          placeholder="Enter content ..."
                          onChange={(value) =>
                            handleChange({
                              target: { name: "headOffice", value },
                            })
                          }
                        />
                      </div>
                      {errors.headOffice && <div className="text-danger small mt-1">{errors.headOffice}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Contact Email
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.contactEmail ? "border-danger" : ""}`}
                        id="contactEmail"
                        name="contactEmail"
                        placeholder="Enter email"
                        value={data.contactEmail}
                        onChange={handleChange}
                      />
                      {errors.contactEmail && <div className="text-danger small mt-1">{errors.contactEmail}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Contact Number
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.contactNumber ? "border-danger" : ""}`}
                        id="contactNumber"
                        name="contactNumber"
                        placeholder="Enter number"
                        value={data.contactNumber}
                        onChange={handleChange}
                      />
                      {errors.contactNumber && <div className="text-danger small mt-1">{errors.contactNumber}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Office Map Url
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.officeMapUrl ? "border-danger" : ""}`}
                        id="officeMapUrl"
                        name="officeMapUrl"
                        placeholder="Enter office map url"
                        value={data.officeMapUrl}
                        onChange={handleChange}
                      />
                      {errors.officeMapUrl && <div className="text-danger small mt-1">{errors.officeMapUrl}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-12 col-form-label"
                    >
                      Address
                    </label>
                  </div>
                  <hr />
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Title
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.titleAdd ? "border-danger" : ""}`}
                        id="titleAdd"
                        name="titleAdd"
                        placeholder="Enter title"
                        value={data.titleAdd}
                        onChange={handleChange}
                      />
                      {errors.titleAdd && <div className="text-danger small mt-1">{errors.titleAdd}</div>}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Address
                    </label>
                    <div className="col-sm-9">
                      <div className={errors.headOfficeAdd ? "border border-danger rounded" : ""}>
                        <CommonEditor
                          value={data.headOfficeAdd}
                          placeholder="Enter content ..."
                          onChange={(value) =>
                            handleChange({
                              target: { name: "headOfficeAdd", value },
                            })
                          }
                        />
                      </div>
                      {errors.headOfficeAdd && <div className="text-danger small mt-1">{errors.headOfficeAdd}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Contact Email
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.contactEmailAdd ? "border-danger" : ""}`}
                        id="contactEmailAdd"
                        name="contactEmailAdd"
                        placeholder="Enter email"
                        value={data.contactEmailAdd}
                        onChange={handleChange}
                      />
                      {errors.contactEmailAdd && <div className="text-danger small mt-1">{errors.contactEmailAdd}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Contact Number
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.contactNumberAdd ? "border-danger" : ""}`}
                        id="contactNumberAdd"
                        name="contactNumberAdd"
                        placeholder="Enter number"
                        value={data.contactNumberAdd}
                        onChange={handleChange}
                      />
                      {errors.contactNumberAdd && <div className="text-danger small mt-1">{errors.contactNumberAdd}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Office Map Url
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control form-control-sm ${errors.officeMapUrlAdd ? "border-danger" : ""}`}
                        id="officeMapUrlAdd"
                        name="officeMapUrlAdd"
                        placeholder="Enter office map url"
                        value={data.officeMapUrlAdd}
                        onChange={handleChange}
                      />
                      {errors.officeMapUrlAdd && <div className="text-danger small mt-1">{errors.officeMapUrlAdd}</div>}
                    </div>
                  </div>
                  <br />
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Culture Video
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className={`form-control form-control-sm ${errors.cultureVideo ? "border-danger" : ""}`}
                        id="cultureVideo"
                        name="cultureVideo"
                        placeholder="Enter culture video"
                        onChange={handleChange}
                      />
                      {errors.cultureVideo && <div className="text-danger small mt-1">{errors.cultureVideo}</div>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername2"
                      className="col-sm-3 col-form-label"
                    >
                      Upload Brochure
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="file"
                        className={`form-control form-control-sm ${errors.uploadBrochure ? "border-danger" : ""}`}
                        id="uploadBrochure"
                        name="uploadBrochure"
                        onChange={handleChange}
                      />
                      {errors.uploadBrochure && <div className="text-danger small mt-1">{errors.uploadBrochure}</div>}
                    </div>
                  </div>


                 <div className="form-group row mt-5 align-items-center">
  <label className="col-sm-3 col-form-label fw-semibold">
    Generate Sitemap
  </label>

  <div className="col-sm-9 d-flex justify-content-end">
    <button
      type="button"
      onClick={generateSitemap}
      className="btn btn-outline-danger px-4 py-2 fw-semibold shadow-sm"
    >
      <i className="bi bi-diagram-3 me-2"></i>
      Generate Sitemap
    </button>
  </div>
</div>




                  <div className="text-center">
                    <Link to="/sliderlist">
                      <button className="btn btn-secondary mr-2">Back </button>
                    </Link>
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>


                   
                </form>









              </div>
            </div>
          </div>
          <div className="col-md-4 stretch-card">
            <div className="card">
              <div className="border w-100 h-500 text-center">
                <h6 className="mt-3">Header Logo Preview</h6>
                {data?.headerLogo instanceof File ? (
                  <img
                    src={URL.createObjectURL(data?.headerLogo)}
                    alt="Preview"
                    className="w-50 mb-4"
                  />
                ) : (
                  <img
                    src={ImageLink(settingData?.headerLogo)}
                    alt="Preview"
                    className="w-50 mb-4"
                  />
                )}
              </div>
              <div className="border w-100 h-500 text-center">
                <h6 className="mt-3">Header Sticky Logo Preview</h6>
                {data?.headerStickyLogo instanceof File ? (
                  <img
                    src={URL.createObjectURL(data?.headerStickyLogo)}
                    alt="Preview"
                    className="w-50 mb-4"
                  />
                ) : (
                  <img
                    src={ImageLink(settingData?.headerStickyLogo)}
                    alt="Preview"
                    className="w-50 mb-4"
                  />
                )}
              </div>
              <div className="border w-100 h-500 text-center">
                <h6 className="mt-3">Footer Logo Preview</h6>
                {data?.footerLogo instanceof File ? (
                  <img
                    src={URL.createObjectURL(data?.footerLogo)}
                    alt="Preview"
                    className="w-50 mb-4"
                  />
                ) : (
                  <img
                    src={ImageLink(settingData?.footerLogo)}
                    alt="Preview"
                    className="w-50 mb-4"
                  />
                )}
              </div>
              {data?.favicon && (
                <div className="border w-100 h-80 text-center ">
                  <h6 className="mt-3">Favicon Logo Preview</h6>
                  {data?.favicon instanceof File ? (
                    <img
                      src={URL.createObjectURL(data?.favicon)}
                      alt="Preview"
                      className="w-30 mb-4"
                    />
                  ) : (
                    <img
                      src={ImageLink(settingData?.favicon)}
                      alt="Preview"
                      className="w-30 mb-4"
                    />
                  )}
                </div>
              )}

              {data?.cultureVideo && (
                <div className="w-100 h-80 text-center">
                  <h6 className="mt-3">Culture Video Preview</h6>
                  {data?.cultureVideo instanceof File ? (
                    <video className="w-50" width="320" height="240" controls>
                      <source
                        src={URL.createObjectURL(data?.cultureVideo)}
                        type="video/mp4"
                      />
                    </video>
                  ) : (
                    <video controls className="w-50" width="320" height="240">
                      <source
                        src={ImageLink(settingData?.cultureVideo)}
                        type="video/mp4"
                      />
                    </video>
                  )}
                </div>
              )}

              {data?.uploadBrochure && (
                <div className=" w-100 h-80 text-center mb-4">
                  <h6 className="mt-3">Upload Brochure Preview</h6>
                  {data?.uploadBrochure instanceof File ? (
                    <Link
                      to={URL.createObjectURL(data?.uploadBrochure)}
                      target="_blank"
                    >
                      <img
                        src="images/icon/pdf.png"
                        alt="pdf"
                        className="ms-3 me-3"
                        width={60}
                      />
                    </Link>
                  ) : (
                    <Link
                      to={ImageLink(settingData?.uploadBrochure)}
                      target="_blank"
                    >
                      <img
                        src="images/icon/pdf.png"
                        alt="pdf"
                        className="ms-3 me-3"
                        width={60}
                      />
                    </Link>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
